/* Middo: galerij-video's starten zodra ze in beeld komen.
   Reden: DeferredMedia in main.js hangt zijn IntersectionObserver alleen aan als er GEEN
   posterknop is, en product-media.liquid rendert die altijd. Dit script vult dat aan,
   ALLEEN voor de productgalerij en ALLEEN voor echte video's.
   Het verwijdert niets en laat de klik-op-poster gewoon werken. Staat JavaScript uit,
   dan gedraagt alles zich precies zoals voorheen. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var gezien = new WeakSet();

  function isEchteVideo(el) {
    var t = el.querySelector('template');
    if (!t) return false;
    var h = t.innerHTML || '';
    // alleen een native <video>; geen model-viewer en geen YouTube/Vimeo-iframe
    return h.indexOf('<video') !== -1 && h.indexOf('model-viewer') === -1 && h.indexOf('<iframe') === -1;
  }

  function hang(el) {
    if (gezien.has(el)) return;
    if (el.hasAttribute('loaded')) return;
    if (typeof el.loadContent !== 'function') return;   // element nog niet opgewaardeerd
    if (!isEchteVideo(el)) return;
    gezien.add(el);
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(el);
        try { el.loadContent(false, false, 'observer'); } catch (err) { /* nooit de pagina breken */ }
      });
    }, { rootMargin: '0px 0px 200px 0px', threshold: 0.25 });
    obs.observe(el);
  }

  function laad(el) {
    if (!el || el.hasAttribute('loaded') || typeof el.loadContent !== 'function') return;
    if (!isEchteVideo(el)) return;
    try { el.loadContent(false, false, 'observer'); } catch (err) { /* nooit de pagina breken */ }
  }

  /* Tweede weg, en de belangrijkste in een SLIDER: het item dat de bezoeker nu ziet.
     In het thema roept alleen handleThumbClick het afspelen aan; met de pijltjes en met
     swipen gebeurt er niets, en customSetActiveMedia doet zelfs pauseAllMedia. Daarom
     kijken we zelf welk item vooraan staat zodra het schuiven tot stilstand komt. */
  function hangSlider(gal) {
    var viewer = gal.querySelector('.media-viewer');
    if (!viewer || viewer.dataset.middoAutoplay) return;
    viewer.dataset.middoAutoplay = '1';
    var t = null;
    viewer.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var items = viewer.querySelectorAll('.media-viewer__item');
        var beste = null, best = Infinity;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(items[i].offsetLeft - viewer.scrollLeft);
          if (d < best) { best = d; beste = items[i]; }
        }
        if (beste) { laad(beste.querySelector('deferred-media')); speelZichtbare(gal); }
      }, 220);
    }, { passive: true });
  }

  /* Middo 09-09-2026: de EERSTE video van een galerij laadt direct, zoals een GIF deed,
     en de video die IN BEELD staat wordt ook echt afgespeeld.
     Twee redenen waarom dat nodig is:
     1. de galerij is een horizontale schuifbalk en de observer heeft alleen een verticale
        rootMargin, dus een video naast het venster komt nooit "in beeld" en blijft op zijn poster;
     2. het attribuut autoplay start een video alleen bij het INLADEN. Het thema roept bij elke
        sliderwissel pauseAllMedia aan, en daarna komt hij uit zichzelf niet meer op gang.
        Gemeten 09-09-2026: video geladen, readyState 4, autoplay true, toch paused. */
  function eersteVideoDirect(gal) {
    var lijst = gal.querySelectorAll('deferred-media');
    for (var i = 0; i < lijst.length; i++) {
      if (!isEchteVideo(lijst[i])) continue;
      laad(lijst[i]);   // laad() slaat over wat al geladen is
      return lijst[i];
    }
    return null;
  }

  /* speel de video van het item dat nu vooraan staat; muted, dus browsers staan dit toe */
  function speelZichtbare(gal) {
    var viewer = gal.querySelector('.media-viewer');
    if (!viewer) return;
    var items = viewer.querySelectorAll('.media-viewer__item');
    var beste = null, best = Infinity;
    for (var i = 0; i < items.length; i++) {
      var d = Math.abs(items[i].offsetLeft - viewer.scrollLeft);
      if (d < best) { best = d; beste = items[i]; }
    }
    if (!beste) return;
    var dm = beste.querySelector('deferred-media');
    if (dm) laad(dm);
    var v = beste.querySelector('video');
    if (!v) return;
    gifStand(v);
  }

  /* laat een galerij-video zich gedragen als een GIF: geen bedieningsbalk, geen posterknop,
     altijd muted en in herhaling, en meteen aan. */
  function gifStand(v) {
    v.muted = true; v.loop = true; v.controls = false;
    v.setAttribute('playsinline', '');
    var wrap = v.closest('deferred-media') || v.parentElement;
    if (wrap) {
      var poster = wrap.parentElement && wrap.parentElement.querySelector('.media-poster');
      if (poster) poster.style.display = 'none';
    }
    // Pauzeren via de video zelf, zonder extra zichtbare bediening.
    if (!v.dataset.middoPauseBound) {
      v.dataset.middoPauseBound = '1';
      var toggle = function () {
        v.dataset.middoUserPaused = v.paused ? '' : '1';
        gifStand(v);
      };
      v.addEventListener('click', toggle);
      v.tabIndex = 0;
      v.setAttribute('aria-label', ({nl:'Video pauzeren of hervatten',de:'Video pausieren oder fortsetzen',fr:'Mettre la vidéo en pause ou reprendre'}[document.documentElement.lang.slice(0, 2)] || 'Pause or resume video'));
      v.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); }
      });
    }
    if (v.dataset.middoUserPaused === '1') v.pause();
    else if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () { }); }
  }

  /* Middo 18-09-2026: de kleine thumbnail van een video beweegt mee, in plaats van een stilstaand
     posterbeeld met een play-icoon. Een kleine <video> komt OVER het posterbeeld; het <img> blijft
     als terugval staan. Bron = dezelfde mp4 als de grote galerij-video (uit zijn <template>). */
  function bewegendeThumbs(gal) {
    gal.querySelectorAll('.media-thumbs__item[data-media-id]').forEach(function (li) {
      if (li.dataset.middoThumb) return;
      var id = li.dataset.mediaId;
      var dm = gal.querySelector('.media-viewer__item deferred-media[data-media-id="' + id + '"]');
      if (!dm) return;
      var src = null, v0 = dm.querySelector('video source[type="video/mp4"]');
      if (v0) src = v0.getAttribute('src');
      else if (isEchteVideo(dm)) {
        var m = (dm.querySelector('template').innerHTML || '').match(/<source[^>]+src="([^"]+)"[^>]*type="video.mp4"/);
        if (m) src = m[1].replace(/&amp;/g, '&');
      }
      var knop = li.querySelector('.media-thumbs__btn');
      if (!src || !knop) return;
      li.dataset.middoThumb = '1';
      var v = document.createElement('video');
      v.muted = true; v.loop = true; v.autoplay = true; v.controls = false;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
      v.preload = 'auto'; v.src = src;
      v.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;pointer-events:none';
      var img = knop.querySelector('img');
      if (img) v.poster = img.currentSrc || img.src;
      knop.appendChild(v);
      // het thema roept bij elke sliderwissel pauseAllMedia aan, dat pauzeert ELKE video op de
      // pagina; een thumbnail start daarna zelf weer
      v.addEventListener('pause', function () {
        setTimeout(function () { if (v.paused) { var q = v.play(); if (q && q.catch) q.catch(function () { }); } }, 250);
      });
      var badge = knop.querySelector('.media-thumbs__badge');
      if (badge) badge.style.display = 'none';
      var p = v.play(); if (p && p.catch) p.catch(function () { });
    });
  }

  function scan() {
    document.querySelectorAll('media-gallery').forEach(function (gal) {
      var eerste = eersteVideoDirect(gal);
      gal.querySelectorAll('deferred-media').forEach(function (el) { if (el !== eerste) hang(el); });
      // elke al geladen galerij-video in GIF-stand zetten, ook de lui geladen
      gal.querySelectorAll('video').forEach(function (v) {
        v.muted = true; v.loop = true; v.controls = false;
      });
      gal.querySelectorAll('.media-poster').forEach(function (knop) {
        var item = knop.closest('.media-viewer__item');
        if (item && item.dataset.mediaType === 'video') knop.style.display = 'none';
      });
      hangSlider(gal);
      bewegendeThumbs(gal);
      speelZichtbare(gal);
    });
  }

  function start() {
    scan();
    // de galerij wisselt items bij een variantkeuze; dan opnieuw kijken
    document.addEventListener('on:variant:change', function () { setTimeout(scan, 150); });
    new MutationObserver(function () { scan(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
